export enum DiffAction {
    CREATE = 1,
    UPDATE,
    DELETE,
}
